document.addEventListener("DOMContentLoaded", () => {
  const locationsBlock = document.querySelector(".locations-view");

  if (locationsBlock) {
    locationsBlock
      .querySelectorAll(".location-wrapper")
      .forEach(function (locationWrapper) {
        locationWrapper.addEventListener("click", function (e) {
          if (!locationWrapper.classList.contains("active")) {
            locationsBlock
              .querySelectorAll(".location-wrapper")
              .forEach(function (otherLocationWrapper) {
                otherLocationWrapper.classList.remove("active");
                otherLocationWrapper.querySelector(
                  ".location-bottom"
                ).style.display = "none";
              });

            locationWrapper.classList.add("active");
            locationWrapper.querySelector(".location-bottom").style.display =
              "block";
          }
        });
      });

      const closeButtons = locationsBlock.querySelectorAll(".views-row .close-button");
    
      closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener("click", function (e) {
          locationsBlock
            .querySelectorAll(".location-wrapper")
            .forEach(function (locationWrapper) {
              locationWrapper.classList.remove("active");
              locationWrapper.querySelector(
                ".location-bottom"
              ).style.display = "none";
            });
        });
      });
  }
});
